export default "__VITE_PUBLIC_ASSET__60389885__"